(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-popup"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var popup = document.querySelector('.campaign-popup-custom');
  if (!popup) return;

  // テーマ側で付いた active を削除して干渉防止
  popup.classList.remove('active');

  // 既に表示済みならスキップ
  if (localStorage.getItem('campaignPopupShown')) return;

  // トップページのみ表示
  if (window.location.pathname !== '/') return;

  // 3秒遅延で表示
  setTimeout(function() {
    popup.classList.add('active');
  }, 3000);

  // 閉じる関数
  function closePopup() {
    popup.classList.remove('active');
    localStorage.setItem('campaignPopupShown', 'true');
  }

  // 閉じるボタン・オーバーレイ
  popup.querySelector('.modal__close-button')?.addEventListener('click', closePopup);
  popup.querySelector('.modal__overlay')?.addEventListener('click', closePopup);
});

  } catch(e) { console.error(e); }
})();
})();
